module.exports = __webpack_public_path__ + "static/media/brokerLogo.0b34f17d.svg";